<template>
    <div style="height: 130vh;">
        <div class="main_slider">
            <swiper class="swiper swiper-container-slider-autod" :options="swiperOption" ref="swiperHome"
                @slideChange="onSlide">
                <swiper-slide v-for="(bannerHero, index) in banners" :key="index">
                    <a :href="bannerHero.redirect_to ? bannerHero.redirect_to : '#'" @click="saveClick(bannerHero.id)">
                        <div class="home__hero container bg-top bg-cover bg-no-repeat flex flex-column justify-content-center
                            xl:justify-content-center align-items-center pt-50 sm:pt-30 xl:pt-42 lg:mb-20"
                            :style="'background-image: url(' + bannerImg[index] + ');'">
                            <div class="tx-center">
                                <div v-if="bannerHero.texts_hidden == 0">
                                    <h2 class="tx-18 sm:tx-18 md:tx-30 xl:tx-42 tx-white">{{ bannerHero.home_text_1 }}</h2>
                                    <h4 class="tx-15 sm:tx-15 md:tx-25 xl:tx-32 tx-white" style="font-weight: 400;">
                                        {{ bannerHero.home_text_2 }}
                                    </h4>

                                </div>
                            </div>
                            <p class="ff-montserrat-bold uppercase tx-center tx-20 sm:tx-15 md:tx-30 xl:tx-40  tx-white mb-3 wow slideInUp"
                                data-wow-delay="1.7s" style="display: none">
                                <span class="tx-white" :class="'typed-animated' + index">
                                </span>
                            </p>
                            <div class="overflow-hidden mb-0 lg:mb-18" v-if="bannerHero.content"></div>
                        </div>
                    </a>
                </swiper-slide>
            </swiper>
        </div>
        <section class="bottom-slider-icons">
            <main-search-component @filters="filters = $event" :data="filters" :inventory-count="inventoryCount">
            </main-search-component>
        </section>
        <section class="bottom-slider-icons-mobile">
            <main-search-component @filters="filters = $event" :data="filters" :inventory-count="inventoryCount">
            </main-search-component>
        </section>
        <partners-component></partners-component>
    </div>
</template>
<script>
import { Swiper, SwiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.css";
import StepperBuyCar from '../home/StepperBuyCar.vue';
export default {
    props: ["inventory-count"],
    components: {
        Swiper,
        SwiperSlide,
        StepperBuyCar,
    },
    data: () => ({
        banners: [],
        filters: {
            brands: null,
            models: null,
            states: null,
            dealerships: null,
            prices: {
                from: null,
                to: null
            },
            zip_code: null
        },
        subastaloUrl: '#',
        currentSlide: 0,
        bannerImg: [],
        swiperOption: {
            centeredSlides: true,
            autoplay: {
                delay: 9000,
                disableOnInteraction: false
            }
        },
        showModalUser: false,
        swiperOptionTop: {
            lazy: true,
            slidesPerView: 3,
            spaceBetween: 8,
            loop: true,
            // loopFillGroupWithBlank: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            breakpoints: {
                540: {
                    slidesPerView: 1
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 12
                },
                1280: {
                    slidesPerView: 3,
                    spaceBetween: 12
                }
            }
        },
    }),
    methods: {
        onSlide() {
            this.currentSlide = this.$refs.swiperHome.$swiper.activeIndex;
        },
        openModalUser() {
            this.showModalUser = true;
        },
        closeModal() {
            this.showModalUser = !this.showModalUser;
        },
        async getBanners() {
            const smallScreens = ['sm']
            const stateId = this.$cookies.get('stateUser') || 0
            const { data } = await axios.get(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/state/${stateId}/banners/filters_used_vehicles`)
            this.banners = smallScreens.includes(this.$mq) || this.$ ? data.mobile : data.desktop
        },
        async saveClick(id) {
            try {
                await axios.post(`${process.env.MIX_API_SUBASTALO_URL}/api/marketplace/save-click`, {
                    banner_id: id,
                });
            } catch (error) {
                console.log(error);
            }
        }
    },
    async mounted() {
        await this.getBanners();
        this.subastaloUrl = process.env.MIX_SUBASTALO_URL

        await this.getBanners()

        for (let index = 0; index < this.banners.length; index++) {
            let img = this.banners[index].url;

            this.bannerImg.push(img)

            var banner = this.banners[index].title;

            new Typed(".typed-animated" + index, {
                strings: [banner],
                typeSpeed: 50,
                cursorChar: ' '
            });
        }
    }
};
</script>

<style lang="scss">
/**
 * swiper class native
 * overwrite the display type of the car mark options at the top of the car cards
 *
 */
.swiper-container {
    max-height: 100vh;
    margin-left: auto;
    margin-right: auto;
    position: relative;
    overflow: hidden;
    list-style: none;
    padding: 0;
    z-index: 0;
}

.swal2-select-override {
    font-size: 1rem;
    background-image: url("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2IiBoZWlnaHQ9IjEwIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGZpbGw9IiM5RUEwQTUiIGQ9Ik0zLjA0NSAwbDIuOTM0IDIuOTM0TDAgMy4wNDUgMy4wNDUgMHptLS4xMDIgOS45OThMMCA3LjA1NWw1Ljk5Ny0uMTEyLTMuMDU0IDMuMDU1eiIvPjwvc3ZnPg==") !important;
    background-position: calc(100% - 7px) 50%;
    background-repeat: no-repeat;
    background-size: 7px;
    overflow: hidden;
    padding-right: 20px;
    cursor: pointer;
}

.swiper-wrapper {
    height: auto;
}
</style>

<style lang="scss" scoped>
.home__hero {
    max-height: calc(50vh - 50px);
    margin: 0px;

    @media screen and (min-width: 1024px) {
        max-height: 100vh;
        height: calc(100vh - (266px + 74px));
    }
}

.main_slider_modified {
    // max-height: 75vh;

    @media screen and (min-width: 1366px) {
        max-height: 100%;
    }
}

#filters_headers_container {
    color: #fff;

    >h2 {
        font-family: 'montserrat-bold';
        font-size: calc(2vw + 10px);

        @media only screen and (max-width: 540px) {
            font-size: calc(2.3vw + 10px);
        }
    }

    >p {
        font-size: calc(1vw + 10px);

        @media only screen and (max-width: 540px) {
            font-size: calc(1.4vw + 10px);
        }
    }
}

#slider_buttons_container {
    font-family: 'montserrat-bold';
    z-index: 9999;
    font-size: 1rem;
    justify-content: center;
    // width: 65%;
    // max-width: 800px;
    width: 678px;
    flex-wrap: wrap;
    margin: auto;

    &>div {
        flex-direction: column;
        width: 100%;

        &>a {
            width: 100%;

            &:first-child {
                margin-bottom: 0.5rem;

                @media screen and (min-width: 1024px) {
                    margin-bottom: 0;
                }
            }

            @media screen and (min-width: 1024px) {
                width: 49%;
            }
        }

        @media screen and (min-width: 1024px) {
            flex-direction: row;
        }
    }

    @media only screen and (max-width: 767px) {
        flex-direction: column;
        height: 242px;
        align-items: center;
        width: 100%;
        flex-wrap: nowrap;
    }

    @media only screen and (max-width: 420px) {
        height: 25vh;
        font-size: calc(1vw + 9px);
    }

    /*     a {
        width: 330px;
        @media screen and (min-width: 420px) and (max-width: 519px) {
            width: 90%;
        }
        @media screen and (min-width: 520px) and (max-width: 767px) {
            width: 70%;
        }
        @media only screen and (max-width: 420px) {
            width: 98%;
            max-height: 43.8px;
        }
    } */
}

#button-buy {
    width: 100% !important;
    /*     width: 678px !important;

    @media screen and (min-width: 420px) and (max-width: 519px) {
        width: 90% !important;
        }
    @media screen and (min-width: 520px) and (max-width: 767px) {
        width: 70% !important;
    }
    @media screen and (min-width: 767px) and (max-width: 1092px) {
        width: 330px !important;
    }
    @media only screen and (max-width: 420px) {
        width: 98% !important;
        max-height: 43.8px;
    } */
}


.bottom-slider-icons {
    width: 100%;
    background-color: #000;
    // padding-bottom: 10px;
    font-weight: 600;
    position: relative;
    z-index: 2;
    height: 266px;
    // margin-top: -200px;
    display: none;
    // position: absolute;
    bottom: 0;

    @media screen and (min-width: 1024px) {
        display: block;
        // margin-top: -260px;
    }
}

.bottom-slider-icons-mobile {
    padding-top: 10px;
    width: 100%;
    background-color: #000;
    // padding-bottom: 20px;
    font-weight: 600;
    position: relative;
    z-index: 2;
    // margin-top: -200px;
    padding-bottom: 20px;
    bottom: 0;
    // position: absolute;

    height: 50vh;

    @media screen and (min-width: 1024px) {
        height: calc(100vh - (220px + 74px));
    }

    @media screen and (min-width: 1024px) {
        display: none;
        // margin-top: -260px;
    }

    >a {
        >h3 {
            font-size: 0.6rem;
        }
    }

    >div>div>div>div {
        color: #fff;
        position: relative;
        // display: grid;
        max-width: 33.33333%;
        padding-top: 5px;
        // grid-template-columns: repeat(auto-fit, 200px);
        // gap: 10px;
        // justify-content: center;
        // justify-items: center;
        border-bottom: 1.5px solid #DBFE54;
        text-align: center;

        >a {
            text-transform: uppercase;
            // border-bottom: 1.5px solid #DBFE54;
            text-align: center;
            margin: 25px 0;

            >img {
                margin-bottom: 20px;
                width: 50px;
            }

            >h3 {
                font-size: 0.6rem;
                margin-bottom: 0;
            }
        }
    }

    >.bottom-slider-icons-mobile-content {
        transform: translateY(calc(50% + 31.5px));

        >.swiper-container {
            margin-bottom: 15px;
        }
    }

    .swiper-button-prev,
    .swiper-button-next {
        top: 50%;
        transform: translateY(-50%);
    }
}

.bottom-slider-icons>div {
    color: #fff;
    position: relative;
    // display: grid;
    width: 100%;

    // grid-template-columns: repeat(auto-fit, 12%);
    // gap: 10px;
    // justify-content: center;
    // justify-items: center;
    >a {
        text-transform: uppercase;
        border-bottom: 1.5px solid #DBFE54;
        text-align: center;
        margin: 25px 0;

        >img {
            margin-bottom: 20px;
            width: 40%;
        }

        >h3 {
            margin-bottom: 0;
            font-size: 16px;
        }
    }

    @media screen and (min-width: 1600px) {
        margin: 0 auto;
        width: 90%;
    }
}


.bottom-slider-icons>a {
    text-transform: none;
    display: block;
    margin: 10px auto;
    font-size: 16px;
}
</style>

